import React, { useState, useEffect, useMemo } from 'react';
import Card from '../../../componentes/contenedores/Card';
import Page from '../../../componentes/plantilla/Page';
import { useContextEmpleado } from '../../../contexto/empleado/EmpleadoContext';
import ModalCargo from './ModalCargo';
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import Tablas from "../../../componentes/tablas/TablasGenerico";
import { createRoot } from "react-dom/client";
import EliminarCargo from './EliminarCargo';

const HomeCargos = () => {
    const { listaCargos, setListaCargos, ActualizarLista } = useContextEmpleado();
    const { token } = useContextUsuario();

    const columnasCargos = useMemo(
        () => [
            { targets: 0, title: "Id", data: "id" },
            { targets: 1, title: "Nombre", data: "nombre_cargo" },
            {
                targets: 2,
                title: "Estado",
                data: "estado",
                render: (data, type) => {
                    if (type === 'export' || type === 'sort') {
                        return data;
                    }
                    return `<span class="badge ${data === "Activo" ? "badge-success" : "badge-danger"
                        }">${data}</span>`;
                }
            },
            {
                targets: 3,
                title: "Opciones",
                data: null,
                orderable: false,
                searchable: false,
                className: "dt-center all",
                exportable: false,
                createdCell: (td, cellData, rowData) => {
                    const root = createRoot(td);
                    root.render(
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1em" }}>
                            <ModalCargo
                                datos={rowData}
                                token={token}
                                setListaCargos={setListaCargos}
                                ActualizarLista={ActualizarLista}
                            />
                            <EliminarCargo
                                datos={rowData}
                                token={token}
                                setListaCargos={setListaCargos}
                                ActualizarLista={ActualizarLista}
                            />
                        </div>
                    );
                },
            },
        ],
        [token, setListaCargos, ActualizarLista]
    );

    const datos = {
        titulo: {
            titulo: "Nuevo cargo",
            url: "/app/empleados",
            tituloUrl: "empleados",
            nombreUrl: "cargos"
        }
    }
    return (
        <Page datos={datos}>
            <Card
                titulo="Modulo de gestión de cargos"
                pie={<ModalCargo token={token} setListaCargos={setListaCargos} ActualizarLista={ActualizarLista} />}
            >
                <div>
                    <p className="card-text">
                        Este módulo ayuda en la organización y administrasión de los roles y responsabilidades de sus empleados.
                    </p>
                </div>
            </Card>
            <Card titulo="Lista de cargos">
                <Tablas
                    datos={listaCargos}
                    columnas={columnasCargos}
                    id="tablaCargos"
                />
            </Card>
        </Page>
    )
}

export default HomeCargos;